import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

import { ZERO_RESULT_SEARCH_KEY } from "./keys";

import type { ZeroResultQueryStatus } from "@/types";
import { ZeroResultSearchRepository } from "@/repositories/zero-result-search";

export const useUpdateZeroResultQueryStatus = () => {
  const queryClient = useQueryClient();
  const repository = useRef(new ZeroResultSearchRepository());

  return useMutation({
    mutationFn: async ({
      id,
      status,
    }: {
      id: string;
      status: ZeroResultQueryStatus;
    }) => {
      return await repository.current.updateStatus(id, status);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate(query) {
          return query.queryKey.includes(ZERO_RESULT_SEARCH_KEY);
        },
      });
    },
  });
};
